<template>
  <h-frame type="right">
    <div class="threeSolidRight">
      <div class="itemDetail">
        <x-title> 民族比例 </x-title>
        <populationRightOne></populationRightOne>
      </div>
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">人户一致标识</div>
        </x-title>
        <div class="rightItem">
          <div class="leftpeople">
            <!-- <div class="yellowColor">人户一致标志</div> -->
            <div class="peopleecharts">
              <div class="oneBox">
                <div class="oneItem" v-for="item in obj" :key="item.id">
                  <span class="bluecolore">{{ item.name }}:</span
                  >{{ item.value }}
                </div>
              </div>
              <div class="oneBluebg">
                <div
                  class="bluecount"
                  :style="{ width: (100 / (num1 + num2)) * num1 + '%' }"
                >
                  {{ num1 }}
                </div>
                <div class="noBlue">{{ num2 }}</div>
              </div>
            </div>
          </div>

          <div class="rightspecial">
            <div class="titleWidth">特殊人员</div>
            <div class="itemList" v-for="item in impotanceCount" :key="item">
              <span class="itenSize">{{ item.value }}</span>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <populationRightTwo></populationRightTwo> -->
      <div class="itemDetail">
        <x-title>
          <div class="titleWidth">流动、固定人口</div>
        </x-title>
        <populationRightThree></populationRightThree>
      </div>
    </div>
  </h-frame>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
import populationRightOne from "./populationRightOne";
import populationRightTwo from "./populationRightTwo";
import populationRightThree from "./populationRightThree";
import { houseHoldType } from "@/api/dataAnalysis/populationAnalysis.js";
import { getImpotanceCount } from "@/api/home/home.js";
export default defineComponent({
  name: "",
  components: { populationRightOne, populationRightTwo, populationRightThree },
  props: {},
  setup(props) {
    const data = reactive({
      regionId: 0,
      obj: [],
      num1: 0,
      num2: 0,
      impotanceCount: [],
    });
    const refData = toRefs(data);
    data.regionId = JSON.parse(localStorage.getItem("regionId"));
    const houseHoldTypelist = async () => {
      const res = await houseHoldType(data.regionId);
      // res.data.forEach((v) => {
      //   data.obj.push({ value: v.value, name: v.name });
      // });
      data.obj = res.data;
      data.num1 = res.data[0].value;
      data.num2 = res.data[1].value;
    };
    //重点人员
    const getImpotanceCountAsync = async () => {
      const params = {
        libraryFlag: "1",
      };
      const res = await getImpotanceCount(params);
      if (res.code == 0) {
        data.impotanceCount = res.data.splice(0, 8);
      }
    };
    houseHoldTypelist();
    getImpotanceCountAsync();
    return {
      ...refData,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidRight {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  padding-top: 10px;
  color: #fff;
  overflow: auto;
  display: grid;
  grid-template-rows: 30% 40% 30%;
  // .itemDetail {
  //   height: 33%;
  // }
  .titleMore {
    float: right;
    cursor: pointer;
    margin-right: 15px;
  }
  .titleYellow {
    width: 100%;
    text-align: center;
    color: #f3ce61;
    line-height: 40px;
  }
  .rightItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    .leftpeople {
      width: 100%;
      // height: 100px;
      display: flex;
      flex-direction: column;
      // margin-bottom: 20px;
      .yellowColor {
        width: 100%;
        text-align: center;
        color: #1a1300;
        line-height: 40px;
      }
      .peopleecharts {
        display: flex;
        flex-direction: column;

        .oneBox {
          display: flex;
          justify-content: space-between;
          line-height: 30px;
          .bluecolore {
            color: #91c8ff;
          }
        }
        .oneBluebg {
          width: 100%;
          height: 30px;
          background: rgba(0, 143, 187, 1);
          border-radius: 4px;
          position: relative;

          .bluecount {
            width: 200px;
            text-align: center;
            // height: 100%;
            position: absolute;
            border-radius: 4px;
            box-shadow: 0 0 10px 3px #00c9fa inset;
            background: #00a8ec;
            z-index: 2;
            line-height: 30px;
          }
          .noBlue {
            position: absolute;
            right: 20px;
            line-height: 30px;
          }
        }
      }
    }
    .rightspecial {
      flex-wrap: wrap;
      display: flex;
      justify-content: space-around;
      // padding: 0px 31px;
      width: 100%;
      .titleWidth {
        width: 100%;
        text-align: center;
      }
    }
    .itemList {
      width: 86px;
      height: 72px;
      display: flex;
      flex-direction: column;
      background-image: url("~@/assets/images/home/yujing.png");
      text-align: center;
      margin-bottom: 24px;
      .itenSize {
        margin-top: 18px;
        margin-bottom: 35px;
      }
    }
  }
  .event {
    width: 100%;
    display: flex;
    flex-direction: column;
    // margin-bottom: 15px;
    .eventTop {
      display: flex;
      margin: 15px 0;
      justify-content: space-around;
      .topItem {
        display: flex;
      }
      .topLeft {
        width: 58px;
        height: 57px;
        margin-right: 10px;
        text-align: center;
        line-height: 57px;
        background-image: url("~@/assets/images/home/yuan.png");
        background-size: cover;
      }
      .topRight {
        display: flex;
        flex-direction: column;
        .sizeNum {
          font-size: 20px;
          margin-bottom: 5px;
        }
      }
    }
  }
  .echarts {
    width: 100%;
    height: 180px;
  }

  .blueColor {
    color: #73f1f3;
  }
  .moreSelect {
    position: absolute;
    bottom: 24px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
  .downBtn {
    padding: 3px 5px;
    background: rgba(0, 0, 0, 0.5);
    // border-radius: 5px;
    position: absolute;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }
}
</style>
